module.exports = __webpack_public_path__ + "img/top-bg.1177b0ea.png";